import React from 'react';
import { Grid } from '@mui/material';
import MetricCard from './MetricCard';


const MetricsGrid = ({ metrics, onRefresh }) => {
  const metricCards = [
    {
      title: 'Total Products',
      value: metrics.totalProducts,
      subtitle: '',
      trend: 'up',
      trendValue: '+12 this week'
    },
    {
      title: 'Verifications Today',
      value: metrics.verificationsToday,
      subtitle: '',
      trend: 'up',
      trendValue: '+23%'
    },
    {
      title: 'Success Rate',
      value: `${metrics.successRate}%`,
      subtitle: '',
      trend: 'up',
      trendValue: '+2.1%'
    },
    {
      title: 'Active NFTs',
      value: metrics.activeNFTs,
      subtitle: '',
      trend: 'up',
      trendValue: '+8 today'
    },
    {
      title: 'Registered Users',
      value: metrics.registeredUsers,
      subtitle: '',
      trend: 'up',
      trendValue: '+47 this week'
    },
    {
      title: 'New Users Today',
      value: metrics.newUsersToday,
      subtitle: '',
      trend: 'up',
      trendValue: '+15%'
    }
  ];

  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      {metricCards.map((metric, index) => (
        <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
          <MetricCard
            {...metric}
            onRefresh={index === 1 || index === 5 ? onRefresh : undefined}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default MetricsGrid;